function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2,
  d: "M14 1C7 1 2 8 2 8s4.7 7 12 7c7 0 12-7 12-7s-5-7-12-7zm0 10.7c-2 0-3.8-1.7-3.8-3.7S12 4.3 14 4.3c2 0 3.8 1.7 3.8 3.7S16 11.7 14 11.7z"
});

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 28 16"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyOCAxNiI+CiAgPHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xNCAxQzcgMSAyIDggMiA4czQuNyA3IDEyIDdjNyAwIDEyLTcgMTItN3MtNS03LTEyLTd6bTAgMTAuN2MtMiAwLTMuOC0xLjctMy44LTMuN1MxMiA0LjMgMTQgNC4zYzIgMCAzLjggMS43IDMuOCAzLjdTMTYgMTEuNyAxNCAxMS43eiIvPgo8L3N2Zz4K";
export { SvgEye as ReactComponent };